import { Component, OnInit } from '@angular/core';

@Component({
  // selector: 'app-layout',
  template: ``,
  styleUrls: ['./layout.component.scss']
})
/*

<app-footer></app-footer>
 <ng-content></ng-content>
  */
export class LayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
